var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgTrainer = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 -5 7 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Events-/-Trainer-/-black",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000300, 0.500100)",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 12.9997,
    x2: 0,
    y2: 12.9997,
    id: "Stroke-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.9424,9.9855 L0.9424,8.9675 C0.9424,7.0645 2.5354,5.5225 4.5004,5.5225 C6.4634,5.5225 8.0564,7.0645 8.0564,8.9675 L8.0564,9.9855 L0.9424,9.9855 Z",
    id: "Stroke-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.9492,1.55 C2.9492,0.694 3.6432,-4.59632332e-14 4.5002,-4.59632332e-14 C5.3552,-4.59632332e-14 6.0502,0.694 6.0502,1.55 C6.0502,2.406 5.3552,3.1 4.5002,3.1 C3.6432,3.1 2.9492,2.406 2.9492,1.55 Z",
    id: "Stroke-11"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.9427,10.4856 L0.9427,9.4676 C0.9427,7.5646 2.5357,6.0226 4.5007,6.0226 C6.4637,6.0226 8.0567,7.5646 8.0567,9.4676 L8.0567,10.4856 L0.9427,10.4856 Z",
    id: "Fill-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.9495,2.0501 C2.9495,1.1941 3.6435,0.5001 4.5005,0.5001 C5.3555,0.5001 6.0505,1.1941 6.0505,2.0501 C6.0505,2.9061 5.3555,3.6001 4.5005,3.6001 C3.6435,3.6001 2.9495,2.9061 2.9495,2.0501",
    id: "Fill-9"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTrainer, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/trainer.5fc87e1e.svg";
export { ForwardRef as ReactComponent };